/* Concentrados Virales · comportamiento de las secciones cvx (VSL, pruebas, para quién, simulador, tu marca, barra de compra) */
(() => {
  if (window.__cvxInit) return; window.__cvxInit = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const ease = t => (t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
  const fmt = n => { const r = Math.round(n * 100) / 100; return '$' + r.toLocaleString('es-MX', { minimumFractionDigits: Number.isInteger(r) ? 0 : 2, maximumFractionDigits: 2 }); };
  const mixWhite = (hex, w) => { const n = parseInt(String(hex).replace('#', ''), 16); const r = n >> 16, g = (n >> 8) & 255, b = n & 255; const m = c => Math.round(c + (255 - c) * w); return `rgb(${m(r)},${m(g)},${m(b)})`; };
  const svgNS = 'http://www.w3.org/2000/svg';
  const ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* Radio-group accesible */
  function radios(group, onChange) {
    const items = $$('[role=radio]', group);
    items.forEach(it => it.addEventListener('click', () => {
      items.forEach(o => o.setAttribute('aria-checked', o === it ? 'true' : 'false'));
      onChange && onChange(it.dataset.v, it);
    }));
    group.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
      const i = items.findIndex(o => o.getAttribute('aria-checked') === 'true');
      const n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
      n.click(); n.focus(); e.preventDefault();
    });
  }

  /* ===== Modal de video (uno para toda la página) ===== */
  let modal, mv, lastFocus;
  function ensureModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'cvx-modal'; modal.hidden = true;
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Video');
    modal.innerHTML = '<div class="cvx-modal__box"><video playsinline controls></video></div><button class="cvx-modal__close" type="button" aria-label="Cerrar video">' + ICON_X + '</button>';
    document.body.appendChild(modal);
    mv = $('video', modal);
    $('.cvx-modal__close', modal).addEventListener('click', closeVideo);
    modal.addEventListener('click', e => { if (e.target === modal) closeVideo(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) closeVideo(); });
  }
  function openVideo(src, poster) {
    if (!src) return;
    ensureModal(); lastFocus = document.activeElement;
    $$('.cvx-player video').forEach(v => { if (!v.muted) v.pause(); });
    mv.src = src; if (poster) mv.poster = poster; else mv.removeAttribute('poster');
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    const p = mv.play(); if (p && p.catch) p.catch(() => {});
    $('.cvx-modal__close', modal).focus();
  }
  function closeVideo() {
    mv.pause(); mv.removeAttribute('src'); mv.load();
    modal.hidden = true; document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ===== VSL ===== */
  function initVsl(root) {
    const box = $('[data-cvx-player]', root); if (!box) return;
    const v = $('video', box), bar = $('[data-cvx-bar]', root);
    if (!v) return;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    const withSound = t => {
      v.muted = false; v.loop = false; v.controls = true;
      try { v.currentTime = t || 0; } catch (_) {}
      box.classList.add('is-on');
      const p = v.play(); if (p && p.catch) p.catch(() => {});
    };
    const over = $('[data-cvx-unmute]', root);
    if (over) over.addEventListener('click', () => withSound(0));
    $$('[data-cvx-t]', root).forEach(b => b.addEventListener('click', () => {
      $$('[data-cvx-t]', root).forEach(x => x.classList.toggle('is-active', x === b));
      withSound(+b.dataset.cvxT || 0);
    }));
    v.addEventListener('timeupdate', () => { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
  }

  /* ===== Pruebas en video ===== */
  function initReels(root) {
    $$('[data-cvx-src]', root).forEach(r => {
      r.addEventListener('click', () => openVideo(r.dataset.cvxSrc, r.dataset.cvxPoster));
      if (fine && !reduce) {
        let pv;
        r.addEventListener('mouseenter', () => {
          pv = document.createElement('video'); pv.src = r.dataset.cvxSrc; pv.muted = true; pv.loop = true; pv.playsInline = true; pv.setAttribute('aria-hidden', 'true');
          r.insertBefore(pv, r.children[1] || null); pv.play().catch(() => {});
        });
        r.addEventListener('mouseleave', () => { if (pv) { pv.pause(); pv.remove(); pv = null; } });
      }
    });
    $$('[data-cvx-filter]', root).forEach(b => b.addEventListener('click', () => {
      $$('[data-cvx-filter]', root).forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      const f = b.dataset.cvxFilter;
      $$('[data-cvx-cat]', root).forEach(r => { r.hidden = !(f === 'all' || r.dataset.cvxCat === f); });
    }));
  }

  /* ===== Para quién (pestañas) ===== */
  function initTabs(root) {
    const tabs = $$('[role=tab]', root);
    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(x => { const on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); const p = root.querySelector('#' + x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
    }));
  }

  /* ===== Simulador ===== */
  function initSim(root) {
    let cfg; try { cfg = JSON.parse($('[data-cvx-sim-data]', root).textContent); } catch (_) { return; }
    const S = { prod: cfg.defaultProd || 'alc', pack: +cfg.defaultPack || 5, dil: +cfg.defaultDil || 2 };
    const dil = () => cfg.dils[S.dil - 1];
    const maxL = Math.max.apply(null, cfg.dils.map(d => d.water + 1));
    const svg = $('[data-cvx-svg]', root);
    const BOTTOM = 332, H = 280, PX = H / maxL;
    const q = s => svg.querySelector(s);

    // escala
    const sc = q('[data-scale]');
    const step = maxL <= 60 ? 5 : 10, major = step * 2;
    for (let L = 0; L <= maxL; L += step) {
      const y = BOTTOM - L * PX, isMajor = L % major === 0;
      const ln = document.createElementNS(svgNS, 'line');
      ln.setAttribute('x1', isMajor ? 100 : 106); ln.setAttribute('x2', 114); ln.setAttribute('y1', y); ln.setAttribute('y2', y);
      ln.setAttribute('stroke', '#57534f'); ln.setAttribute('stroke-width', isMajor ? 1.6 : 1); sc.appendChild(ln);
      if (isMajor) { const tx = document.createElementNS(svgNS, 'text'); tx.setAttribute('x', 96); tx.setAttribute('y', y + 4); tx.setAttribute('text-anchor', 'end'); tx.textContent = L + ' L'; sc.appendChild(tx); }
    }
    // marcas de dilución
    const mk = q('[data-marks]'), markEls = [];
    cfg.dils.forEach((d, i) => {
      const L = d.water + 1, y = BOTTOM - L * PX, g = document.createElementNS(svgNS, 'g');
      g.innerHTML = `<line x1="300" x2="312" y1="${y}" y2="${y}" stroke="currentColor" stroke-width="2"/><text x="316" y="${y + 4}" fill="currentColor">${String(d.name).toUpperCase()} ${L} L</text>`;
      g.setAttribute('color', '#6b6662'); mk.appendChild(g); markEls[i] = g;
    });
    // burbujas
    const bubG = q('[data-bubbles]'), bubbles = [];
    for (let i = 0; i < 14; i++) { const c = document.createElementNS(svgNS, 'circle'); c.setAttribute('r', 2 + Math.random() * 3.5); c.setAttribute('opacity', 0); bubG.appendChild(c); bubbles.push({ el: c, x: 132 + Math.random() * 156, d: Math.random() * .6, sp: .6 + Math.random() * .8 }); }

    const color = () => cfg.colors[S.prod];
    const whites = [0, .22, .5];
    function drawFrame(t) {
      const col = color(), water = dil().water;
      const tA = clamp(t / .22, 0, 1), tB = clamp((t - .22) / .56, 0, 1), tC = clamp((t - .78) / .22, 0, 1);
      const drop = q('[data-drop]');
      drop.setAttribute('fill', col);
      if (tA < 1) { const y = -30 + ease(tA) * (BOTTOM - 10 + 30); drop.setAttribute('transform', `translate(170 ${y}) scale(${1 - tA * .2})`); drop.setAttribute('opacity', 1); }
      else drop.setAttribute('opacity', 0);
      const concH = (tA >= .98 ? 1 : 0) * PX;
      const waterL = ease(tB) * water, waterH = waterL * PX, totalH = concH + waterH;
      const conc = q('[data-conc]'), wat = q('[data-water]'), mixr = q('[data-mix]'), surf = q('[data-surf]');
      conc.setAttribute('fill', col); conc.setAttribute('y', BOTTOM - concH); conc.setAttribute('height', concH);
      wat.setAttribute('y', BOTTOM - concH - waterH); wat.setAttribute('height', waterH);
      mixr.setAttribute('fill', mixWhite(col, whites[S.dil - 1] ?? .22)); mixr.setAttribute('y', BOTTOM - totalH); mixr.setAttribute('height', totalH); mixr.setAttribute('opacity', ease(tC));
      surf.setAttribute('y', BOTTOM - totalH - 1); surf.setAttribute('opacity', totalH > 0 ? .35 : 0);
      const ws = q('[data-stream]');
      ws.setAttribute('height', tB > 0 && tB < 1 ? Math.max(0, BOTTOM - totalH - 44) : 0);
      bubbles.forEach(b => {
        const p = clamp((tC - b.d * .5) * b.sp * 1.6, 0, 1), y = BOTTOM - 6 - p * (totalH - 10);
        b.el.setAttribute('cx', b.x + Math.sin((p + b.d) * 9) * 4); b.el.setAttribute('cy', y);
        b.el.setAttribute('opacity', tC > 0 && p < 1 ? .55 * (1 - p) : 0);
      });
      const lab = q('[data-label]'), inside = totalH > 70;
      lab.textContent = Math.round(1 + waterL) + ' L';
      lab.setAttribute('y', inside ? BOTTOM - totalH / 2 + 15 : BOTTOM - totalH - 14);
      lab.setAttribute('opacity', tB > 0 ? 1 : 0);
      lab.setAttribute('fill', inside && tC > .5 ? '#111' : '#fff');
      const st = $$('[data-step]', root);
      if (st[0]) st[0].classList.toggle('on', t > .02);
      if (st[1]) st[1].classList.toggle('on', tB > .02);
      if (st[2]) st[2].classList.toggle('on', tC > .5);
    }
    let raf, animId = 0;
    function play() {
      cancelAnimationFrame(raf); const id = ++animId;
      if (reduce) { drawFrame(1); return; }
      const dur = 1500 + dil().water * 35, t0 = performance.now();
      const stepF = now => { if (id !== animId) return; const t = clamp((now - t0) / dur, 0, 1); drawFrame(t); if (t < 1) raf = requestAnimationFrame(stepF); };
      raf = requestAnimationFrame(stepF);
    }

    const porron = (frac, col) => {
      const h = 20 * frac;
      return `<svg viewBox="0 0 22 30" aria-hidden="true"><path d="M5 7h12l2 4v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V11z" fill="#2a2827" stroke="#5c5856" stroke-width="1.2"/><rect x="8" y="2" width="6" height="5" rx="1" fill="#5c5856"/>${h > 0 ? `<rect x="4" y="${28 - h}" width="14" height="${h}" rx="1" fill="${col}"/>` : ''}</svg>`;
    };
    const precio = $('[data-precio]', root), envase = $('[data-envase]', root);
    const paint = r => r && r.style.setProperty('--p', ((r.value - r.min) / (r.max - r.min) * 100) + '%');
    const packInfo = () => (cfg.products[S.prod] || {})[S.pack] || null;
    const packPrice = () => { const p = packInfo(); return p && p.price ? p.price / 100 : (cfg.fallback[S.pack] || 0); };

    function money() {
      if (!precio || !envase) return;
      const litros = S.pack * (dil().water + 1), inv = packPrice(), p = +precio.value, e = +envase.value;
      paint(precio); paint(envase);
      $('[data-precio-out]', root).textContent = fmt(p); $('[data-envase-out]', root).textContent = fmt(e);
      const venta = litros * p, env = litros * e, gan = venta - inv - env;
      $('[data-m-venta-lbl]', root).textContent = `Vendes ${litros.toLocaleString('es-MX')} L a ${fmt(p)}`;
      $('[data-m-venta]', root).textContent = fmt(venta);
      $('[data-m-inv]', root).textContent = '−' + fmt(inv);
      $('[data-m-env]', root).textContent = '−' + fmt(env);
      $('[data-m-gan]', root).textContent = (gan < 0 ? '−' : '') + fmt(Math.abs(gan));
      const c = $('[data-m-callout]', root);
      if (p <= e) c.innerHTML = 'Con ese precio no cubres el envase. <b>Sube tu precio de venta.</b>';
      else if (gan <= 0 || S.pack === 1) c.innerHTML = 'Con 1 concentrado es para usarlo o probarlo. <b>Para vender te conviene el paquete de 5.</b>';
      else c.innerHTML = `Recuperas lo del concentrado vendiendo <b>${Math.ceil(inv / (p - e)).toLocaleString('es-MX')} L</b>. Lo demás ya es ganancia.`;
    }

    function update(animate) {
      const d = dil(), yieldL = d.water + 1, litros = S.pack * yieldL, inv = packPrice(), col = color();
      root.style.setProperty('--sel-prod', col);
      $('[data-dil-out]', root).textContent = `1 L + ${d.water} L de agua`;
      $('[data-dil-hint]', root).textContent = d.hint || '';
      const st = $$('[data-step]', root);
      if (st[0]) st[0].textContent = '1 L concentrado';
      if (st[1]) st[1].textContent = `+ ${d.water} L agua`;
      if (st[2]) st[2].textContent = `= ${yieldL} L listos`;
      markEls.forEach((g, i) => g.setAttribute('color', i === S.dil - 1 ? col : '#6b6662'));
      const dg = $('[data-dil-group]', root); if (dg) dg.style.setProperty('--sel', col);
      $('[data-r-litros]', root).textContent = litros.toLocaleString('es-MX') + ' L';
      $('[data-r-costo]', root).textContent = litros ? fmt(inv / litros) : '—';
      $('[data-r-botellas]', root).textContent = litros.toLocaleString('es-MX');
      const porr = litros / 20;
      const porrTxt = Number.isInteger(porr) ? porr : porr.toLocaleString('es-MX', { maximumFractionDigits: 1 });
      $('[data-porron-cap]', root).innerHTML = porr < 1 ? 'Llenas <b>medio porrón de 20 L</b>' : `Llenas <b>${porrTxt} porr${porr === 1 ? 'ón' : 'ones'} de 20 L</b>`;
      let html = ''; const full = Math.floor(porr), rest = porr - full;
      for (let i = 0; i < Math.min(full, 60); i++) html += porron(1, col);
      if (rest > 0) html += porron(rest, col);
      const pw = $('[data-porrones]', root); pw.innerHTML = html;
      if (!reduce && pw.animate) $$('svg', pw).forEach((s, i) => s.animate([{ transform: 'translateY(6px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 260, delay: Math.min(i * 35, 700), fill: 'backwards', easing: 'ease-out' }));
      // botón de compra
      const info = packInfo(), form = $('[data-cvx-buy]', root), btn = form && $('[type=submit]', form), link = $('[data-cvx-buy-link]', root);
      const label = `${cfg.buyLabel} ${S.pack} concentrado${S.pack > 1 ? 's' : ''} · ${fmt(inv)}`;
      if (form && info && info.id) {
        form.hidden = false; if (link) link.hidden = true;
        $('[name=id]', form).value = info.id; btn.textContent = info.available ? label : cfg.soldOut; btn.disabled = !info.available;
      } else { if (form) form.hidden = true; if (link) { link.hidden = false; link.textContent = label; } }
      money();
      if (animate) play(); else drawFrame(1);
    }

    radios($('[data-prod-group]', root), v => { S.prod = v; update(true); });
    radios($('[data-pack-group]', root), v => { S.pack = +v; update(false); });
    radios($('[data-dil-group]', root), v => { S.dil = +v; update(true); });
    if (precio) precio.addEventListener('input', money);
    if (envase) envase.addEventListener('input', money);
    const rp = $('[data-replay]', root); if (rp) rp.addEventListener('click', play);
    update(false);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { play(); io.disconnect(); } }), { threshold: .35 });
      io.observe(svg);
    }
  }

  /* ===== Tu marca ===== */
  function initBrand(root) {
    let cfg; try { cfg = JSON.parse($('[data-cvx-brand-data]', root).textContent); } catch (_) { cfg = {}; }
    const B = { prod: 'alc', top: 'spray' };
    const input = $('[data-brand-name]', root), tx = $('[data-b-name]', root);
    const fit = () => {
      tx.textContent = (input.value.trim() || cfg.placeholder || 'TU MARCA').toUpperCase();
      let fs = 26; tx.setAttribute('font-size', fs);
      try { while (tx.getComputedTextLength() > 74 && fs > 10) { fs -= 1; tx.setAttribute('font-size', fs); } } catch (_) {}
    };
    const paint = () => {
      const col = (cfg.colors || {})[B.prod] || '#ff2d95';
      $('[data-b-liquid]', root).setAttribute('fill', mixWhite(col, .12));
      $$('[data-b-band]', root).forEach(e => e.setAttribute('fill', col));
      const t = $('[data-b-type]', root); t.setAttribute('fill', col); t.textContent = ((cfg.types || {})[B.prod] || '').toUpperCase();
      $('[data-b-spray]', root).style.display = B.top === 'spray' ? '' : 'none';
      $('[data-b-cap]', root).style.display = B.top === 'cap' ? '' : 'none';
    };
    input.addEventListener('input', fit);
    radios($('[data-bprod-group]', root), v => { B.prod = v; paint(); });
    radios($('[data-btop-group]', root), v => { B.top = v; paint(); });
    paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit); else fit();
  }

  /* ===== Barra fija de compra (celular) ===== */
  function initBuybar(root) {
    const bar = $('.cvx-buybar', root) || root;
    if (!('IntersectionObserver' in window)) return;
    const watched = $$('[data-cvx="vsl"], #productos, .cvx-final');
    if (!watched.length) { bar.classList.add('show'); return; }
    const vis = new Map();
    const io = new IntersectionObserver(es => {
      es.forEach(en => vis.set(en.target, en.isIntersecting));
      const anyVisible = Array.from(vis.values()).some(Boolean);
      bar.classList.toggle('show', !anyVisible);
    }, { threshold: 0.05 });
    watched.forEach(w => { vis.set(w, true); io.observe(w); });
  }

  const INIT = { vsl: initVsl, reels: initReels, tabs: initTabs, sim: initSim, brand: initBrand, buybar: initBuybar };
  function boot(scope) {
    $$('[data-cvx]', scope || document).forEach(root => {
      if (root.__cvxDone) return; root.__cvxDone = true;
      const fn = INIT[root.dataset.cvx]; if (fn) { try { fn(root); } catch (err) { console.error('cvx', root.dataset.cvx, err); } }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
